// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var FWeightNormal = /* #__PURE__ */ (function () {
    function FWeightNormal() {

    };
    FWeightNormal.value = new FWeightNormal();
    return FWeightNormal;
})();
var FWeightBold = /* #__PURE__ */ (function () {
    function FWeightBold() {

    };
    FWeightBold.value = new FWeightBold();
    return FWeightBold;
})();
var FWeightBolder = /* #__PURE__ */ (function () {
    function FWeightBolder() {

    };
    FWeightBolder.value = new FWeightBolder();
    return FWeightBolder;
})();
var FWeightNumber = /* #__PURE__ */ (function () {
    function FWeightNumber(value0) {
        this.value0 = value0;
    };
    FWeightNumber.create = function (value0) {
        return new FWeightNumber(value0);
    };
    return FWeightNumber;
})();
var showFontWeight = {
    show: function (v) {
        if (v instanceof FWeightNormal) {
            return "FWeightNormal";
        };
        if (v instanceof FWeightBold) {
            return "FWeightBold";
        };
        if (v instanceof FWeightBolder) {
            return "FWeightBolder";
        };
        if (v instanceof FWeightNumber) {
            return "(FWeightNumber " + (show(v.value0) + ")");
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontWeight (line 17, column 10 - line 21, column 58): " + [ v.constructor.name ]);
    }
};
var printFontWeight = function (v) {
    if (v instanceof FWeightNormal) {
        return "normal";
    };
    if (v instanceof FWeightBold) {
        return "bold";
    };
    if (v instanceof FWeightBolder) {
        return "bolder";
    };
    if (v instanceof FWeightNumber) {
        return show(v.value0);
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontWeight (line 24, column 19 - line 28, column 28): " + [ v.constructor.name ]);
};
var eqFontWeight = {
    eq: function (x) {
        return function (y) {
            if (x instanceof FWeightNormal && y instanceof FWeightNormal) {
                return true;
            };
            if (x instanceof FWeightBold && y instanceof FWeightBold) {
                return true;
            };
            if (x instanceof FWeightBolder && y instanceof FWeightBolder) {
                return true;
            };
            if (x instanceof FWeightNumber && y instanceof FWeightNumber) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
export {
    FWeightNormal,
    FWeightBold,
    FWeightBolder,
    FWeightNumber,
    printFontWeight,
    eqFontWeight,
    showFontWeight
};
